import { removeOWAConnectedAccount } from 'owa-accounts-store';
import { removeUserMailboxInfo } from 'owa-client-ids';
import { orchestrator } from 'satcheljs';
import { removeUserConfiguration } from 'owa-session-store';

orchestrator(removeOWAConnectedAccount, async ({ primarySmtpAddress }) => {
    // step 1. clear the cache with calendars and items belonging to removed account
    // to do: VSO 49209

    // step 2. clear the user configuration for the removed account
    removeUserConfiguration(primarySmtpAddress);

    // step 3: clear the mailboxInfo for the removed account
    removeUserMailboxInfo(primarySmtpAddress);
});
